var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./campaignBanner"));
    processInclude(require("./dataLayer/homePage"));
    processInclude(require("./pdButton"));
    processInclude(require("./pdProductGrid"));
});
